import http from "../utils/http-common";

const post = (data: any) => {
  return http.post(`/notification`, data);
};

const get = () => {
  return http.get(`/notification`);
};

const getByUser = (userId: number | string) => {
  return http.get(`/notification/user/${userId}`);
};

const put = (notificationId: number, data: any) => {
  return http.put(`/notification/${notificationId}`, data);
};

const remove = (notificationId: number) => {
  return http.delete(`/notification/${notificationId}`);
};

export const notificationService = {
  post,
  get,
  getByUser,
  put,
  remove,
};
